/*
 * 방문 기록 비컨 — 2026-10-30 (extend/_track.php · page/ajax_track.php · 기획서 방문분석_수집_기획_2026-10-30.md)
 *
 * 하는 일
 *   · 페이지가 그려지면 「js」 한 번 — 서버가 그 세션을 「사람」으로 확정한다(봇은 스크립트를 돌리지 않는다). 화면 폭도 함께.
 *   · 바깥으로 나가는 누름 — 전화 걸기(tel:) · 떠 있는 네이버 예약 단추 · 다른 사이트 링크(호스트만)
 *   · 메인 섹션 도달 — .sec.sec-{메뉴} 가 3분의 1 넘게 보이면 한 번(어느 섹션까지 보나 — 레이아웃 고를 근거)
 *   · 예약 창 안의 날짜 고름·마감 누름은 app.js booking() 이 window.yzTrack() 으로 넘긴다
 *
 * 보내는 방법 — 추천 노출 비컨(recom-stat.js)과 같다: 모아 두었다가 5초마다 · 페이지를 떠날 때 sendBeacon 으로 한 번에. 줄 모양 「이름|상품|값」.
 * 서버가 이름 목록 밖은 버리므로 아무 이름이나 보내도 쌓이지 않는다. 파트너센터 미리보기·관리자 시험 모드는 서버가 걸러 적지 않는다.
 */
(function () {
	'use strict';
	var C = window.YZ_TRACK;
	if (!C || !C.url) return;

	var q = [];
	function send() {
		if (!q.length) return;
		var body = 'e=' + encodeURIComponent(q.join('\n'));
		q = [];
		if (navigator.sendBeacon) {
			try {
				if (navigator.sendBeacon(C.url, new Blob([body], { type: 'application/x-www-form-urlencoded' }))) return;
			} catch (err) { /* 아래 일반 요청으로 */ }
		}
		var x = new XMLHttpRequest();
		x.open('POST', C.url, true);
		x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
		x.send(body);
	}
	function track(name, co, val) {
		q.push(String(name) + '|' + (parseInt(co, 10) || 0) + '|' + String(val == null ? '' : val).replace(/[\n|]/g, ' ').slice(0, 100));
		if (q.length >= 40) send();
	}
	window.yzTrack = track;

	// 사람 확정 + 화면 폭 — 1.5초 뒤 첫 묶음으로(그 사이 생긴 다른 이벤트와 함께)
	track('js', window.innerWidth || 0, '');

	// 바깥 이동 — 누름 순간 바로 보낸다(페이지를 떠나며 놓치지 않게)
	document.addEventListener('click', function (ev) {
		var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
		if (!a) return;
		var h = a.getAttribute('href') || '';
		if (/^tel:/i.test(h)) { track('out_tel', 0, h.replace(/^tel:/i, '').replace(/\D/g, '')); send(); return; }
		if (a.classList.contains('btn-naver-open')) { track('out_naver', 0, ''); send(); return; }
		try {
			var u = new URL(a.href, location.href);
			if (/^https?:$/.test(u.protocol) && u.host && u.host !== location.host) { track('out_link', 0, u.host); send(); }
		} catch (err) { /* 주소가 아니면 넘어감 */ }
	}, true);

	// 메인 섹션 도달
	if (window.IntersectionObserver) {
		var secs = document.querySelectorAll('.sec[class*="sec-"]');
		if (secs.length) {
			var seen = {};
			var io = new IntersectionObserver(function (es) {
				es.forEach(function (e) {
					if (!e.isIntersecting) return;
					var m = /\bsec-([a-z]+)\b/.exec(e.target.className || '');
					if (!m || seen[m[1]]) return;
					seen[m[1]] = 1;
					track('sec_reach', 0, m[1]);
					io.unobserve(e.target);
				});
			}, { threshold: 0.35 });
			secs.forEach(function (s) { io.observe(s); });
		}
	}

	document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') send(); });
	window.addEventListener('pagehide', send);
	setTimeout(send, 1500);
	setInterval(send, 5000);
})();
